// Toutes les traductions sont en français uniquement.
export type Lang = 'fr'

export const translations = {
  // Commun
  app_name:        'Stoke',
  save:            'Enregistrer ✓',
  cancel:          'Annuler',
  confirm:         'Confirmer',
  delete:          'Supprimer',
  edit:            'Modifier',
  close:           'Fermer',
  back:            'Retour',
  loading:         'Chargement...',
  search:          'Chercher...',
  optional:        '(optionnel)',
  required:        'Obligatoire',
  total:           'Total',
  today:           "Aujourd'hui",
  details:         'Détails',
  add:             '+ Ajouter',
  no_data:         'Aucune donnée',
  error_db:        'Connexion base impossible — vérifier WAMP',
  retry:           'Réessayer',
  dt:              'DT',
  note:            'Note',

  // Navigation / Rôles
  role_patron:     '👑 Patron',
  role_vendeur:    '🛒 Vendeur',
  role_caissier:   '💰 Caissier',

  // Login
  choose_shop:     'Choisir la boutique',
  who_are_you:     'Qui êtes-vous?',
  enter_pin:       'Entrer le PIN',
  pin_wrong:       'PIN incorrect ❌',
  no_shop:         'Aucune boutique',
  create_shop:     'Créer une boutique',

  // Dashboard
  hello:           'Bonjour',
  caisse_today:    "Caisse aujourd'hui",
  current_balance: 'Solde actuel',
  caisse_closed:   'Caisse pas encore ouverte',
  open_caisse:     'Ouvrir →',
  stock_alert:     '⚠️ Alertes stock',
  nav_vente:       'Vente',
  nav_articles:    'Articles',
  nav_caisse:      'Caisse',
  nav_clients:     'Clients',
  nav_rapport:     'Rapport',
  nav_chat:        'AI Chat',
  nav_settings:    'Paramètres',

  // Vente
  vente_title:     'Vente',
  scan_barcode:    'Scanner code-barres',
  search_article:  'Chercher article...',
  cart_empty:      'Scanner un code-barres\nou chercher un article',
  cart_label:      'Panier',
  empty_cart:      'Vider',
  article_not_found: 'Article introuvable',
  confirm_vente:   'Confirmer la vente',
  vente_done:      'Vente enregistrée! ✅',
  associate_client:'Associer un client (optionnel)',
  pay_now:         'Payé maintenant:',
  all:             'Tout',
  karde_partial:   '💳 Kardé — paiement partiel',
  paid_full:       '✅ Payé en entier',
  karde_this_sale: 'Kardé cette vente',
  client_balance_after: 'Solde client après',
  client_owes:     'doit',
  client_credit:   'crédit',
  client_settled:  'soldé ✓',
  price_too_low:   '⚠️ Prix trop bas!',
  min_price:       'Prix min:',
  selling_at:      'Tu vends à:',
  confirm_anyway:  'Confirmer quand même',
  below_min:       'Sous le minimum',

  // Ticket
  ticket_title:    'Ticket de vente ✅',
  print_ticket:    '🖨️ Imprimer le ticket',
  thank_you:       '— Merci pour votre achat! —',
  remaining_debt:  '⚠️ Reste à payer:',
  remaining_credit:'✅ Crédit restant:',

  // Articles
  articles_title:  'Articles',
  new_article:     'Nouvel article',
  stock_low:       'Stock faible',
  all_articles:    'Tout',
  unit_piece:      'pièce',
  unit_kg:         'kg',
  unit_litre:      'litre',
  unit_box:        'boîte',
  ras_mel:         'Ras mel',
  prix_vente:      'Prix vente',
  prix_min:        'Prix min',
  stock_label:     'Stock',
  stock_alert_label:'Alert quand:',
  margin:          'Marge',
  category:        'Catégorie',
  barcode:         'Référence',
  name:            'Nom',
  unit:            'Unité',
  article_name_ph: 'Ex: TV Samsung',

  // Article New
  scan_ref:        '📷 Scanner le code-barres',
  scan_point:      'Pointe la caméra vers le code',
  enter_ref:       'Saisir la référence',
  ref_ph:          'Ex: CRDN570ZX',
  verify:          'Vérifier →',
  step_article:    '1. Article',
  step_prix:       '2. Prix',
  step_stock:      '3. Stock',
  tip_rasmel:      '💡 Ras mel = prix achat. Prix min = en dessous = alerte!',
  recap:           'Récap',
  article_added:   'Article ajouté! ✅',
  add_another:     '+ Ajouter une autre',
  see_articles:    'Voir les articles',
  change:          'Changer',
  next:            'Suivant →',
  finish:          'Enregistrer ✓',

  // Caisse
  caisse_title:    'Caisse',
  theoretical_balance: 'Solde théorique',
  opening_balance: 'Solde ouverture',
  sales:           'Ventes',
  withdrawals:     'Retraits',
  charges:         'Charges',
  clients_label:   'Clients',
  add_withdrawal:  'Retrait caisse',
  add_charge:      'Ajouter charge',
  open_caisse_btn: 'Ouvrir la caisse',
  close_caisse:    '🔒 Fermer la caisse',
  caisse_closed_badge: 'Fermée',
  how_much_opening:'Combien tu as dans la caisse au départ?',
  withdrawal_note: 'Pour quoi? (kré7, achat...)',
  kre7:            'Kré7',
  steg:            'STEG',
  sonede:          'SONEDE',
  salaire:         'Salaire',
  transport:       'Transport',
  autre:           'Autre',
  day_sales:       'Ventes du jour',
  client_payments: 'Paiements clients',
  day_withdrawals: 'Retraits du jour',
  day_charges:     'Charges du jour',
  karde_badge:     'kardé',
  real_balance:    'Solde réel compté',
  gap:             'Écart',
  encaisse:        'Encaissé',

  // Clients
  clients_title:   'Clients',
  new_client:      'Nouveau client',
  total_credit:    'Total crédits',
  total_debt:      'Total dettes',
  credit:          'crédit',
  debt:            'dette',
  settled:         'soldé',
  client_name_ph:  'Nom du client *',
  phone:           'Téléphone',
  current_balance_client: 'Solde actuel',
  owes_msg:        'Le client doit payer',
  credit_msg:      'Crédit disponible',
  receive_payment: '💵 Paiement reçu',
  receive_payment_desc: 'Rembourse sa dette',
  advance:         '💰 Avance',
  advance_desc:    'Pré-paiement',
  karde_situation: '📋 Situation kardé',
  credit_purchases:'Achats à crédit (net)',
  advances_given:  'Avances données',
  payments_received:'Paiements reçus',
  remaining_to_pay:'Reste à payer',
  history:         'Historique',
  no_transactions: 'Aucune transaction',
  advance_tx:      'Avance',
  payment_tx:      'Paiement reçu',
  sale_tx:         'Achat à crédit',
  new_balance:     'Nouveau solde',
  amount:          'Montant...',
  note_ph:         'Note (optionnel)',
  payment_confirm: 'Confirmer',
  delete_client:   'Supprimer ce client',

  // Rapport
  rapport_title:   'Rapport',
  period_today:    "Aujourd'hui",
  period_week:     '7 jours',
  period_month:    'Ce mois',
  net_profit:      'Bénéfice net',
  gross_profit:    'Bénéfice brut',
  turnover:        "Chiffre d'affaires",
  cost:            '− Coût (ras mel)',
  gross:           '= Bénéfice brut',
  charges_minus:   '− Charges',
  net:             '= Bénéfice NET',
  on_goods_sold:   'sur marchandise vendue',
  treasury:        '💵 Trésorerie (cash reçu)',
  encaisse_on_sales:'Encaissé sur ventes',
  client_payments_received: 'Paiements clients reçus',
  total_cash_in:   '= Cash entré total',
  karde_not_encaisse: 'Vendu pas encore encaissé (kardé)',
  karde_current:   'Kardé en cours (total)',
  clients_to_recover: 'client(s) à recouvrer',
  sales_per_day:   'Ventes par jour',
  top_articles:    'Top articles',
  sold_count:      'vendus',
  result_label:    '📊 Résultat',
  after_charges:   'après charges',

  // Settings
  settings_title:  'Paramètres',
  language:        'Langue',
  french:          'Français 🇫🇷',
} as const

export type TKey = keyof typeof translations
